import {ListeAlertes} from "../common/alerte/listeAlertes";
import {ListItem} from "../common/list-view/list-item";
import {User} from "../user/user";
import {Statut} from "../workflow/statut";
import {AbstractObjetWorkflow} from "../workflow/abstract-objet-workflow";
import {TypePortee} from "../workflow/workflow";
import {MapAction} from "../workflow/mapAction";
import {Pays} from "../geographie/pays";
import {TranslateService} from "@ngx-translate/core";
import {UserPipeTransform} from "@share/pipe/user.pipe";

/**
 * Modèle représentant un OD listé
 */
export class ListeOd extends AbstractObjetWorkflow implements ListItem {
    idOd: number;
	idOmPermanent: number;
	objet: string;
	depart_le: Date;
	retour_le: Date;
    ville: string;
	libelleVille: string;
	pays: Pays;
	lieu: string;
	typeEntite: string;
	montantProposition: number;
    dateLimiteApprobation: Date;
    statut: Statut;
    user: User;
	listeAlertes: ListeAlertes;
	listeHistoWorkflow: MapAction;
    budgetOk: boolean;

    constructor(dto: any) {
        super();
        if (dto) {
            this.idOd = dto.idOd;
            this.idOmPermanent = dto.idOmPermanent;
            this.objet = dto.objet;
            if (dto.depart_le) { this.depart_le = new Date(dto.depart_le) }
            if (dto.retour_le) { this.retour_le = new Date(dto.retour_le) }
            this.ville = dto.ville;
            this.libelleVille = dto.libelleVille;
            this.pays = dto.pays as Pays;
            this.lieu = dto.lieu;
            this.typeEntite = dto.typeEntite;
            this.montantProposition = dto.montantProposition;
            if (dto.dateLimiteApprobation) { this.dateLimiteApprobation = new Date(dto.dateLimiteApprobation) }
            this.statut = dto.statut as Statut;
            this.user = dto.user as User;
            this.listeAlertes = dto.listeAlertes as ListeAlertes;
            if (dto.listeHistoWorkflow) { this.listeHistoWorkflow = new MapAction(dto.listeHistoWorkflow); }
            this.masque = dto.masque;
            this.budgetOk = dto.budgetOk;
        }
    }

    /** Indicateur d'affichage de l'élément */
    isDisplayed?: boolean;

    /** Indicateur de sélection de l'élément */
    isSelected?: boolean;

    /**
     * Getter pour l'affichage de l'endroit
     */
    get location(): string {
        if (this.libelleVille) { return this.libelleVille; }
        if (this.ville) { return this.ville; }
        if (this.lieu) { return this.lieu; }
        if (this.pays?.libelle) { return this.pays.libelle; }
        return null;
    }

    /**
     * Récupération de l'identifiant de l'objet
     * @returns l'identifiant de l'objet
     */
    getKey(): number {
        return this.idOd;
    }

    getId(): number {
        return this.idOd;
    }

    getPortee(): TypePortee {
        return TypePortee.OD;
    }

    getListeAlertes(): ListeAlertes {
        return this.listeAlertes;
    }

    getMapAction(): MapAction {
        return this.listeHistoWorkflow;
    }

    setListeAlertes(listeAlertes: ListeAlertes): void {
        this.listeAlertes = listeAlertes;
    }

    /**
     * Getter pour le collaborateur
     */
    getCollaborateur(): String {
        if (!this.user) { return null; }
        else return UserPipeTransform(this.user);
    }

    /**
     * Getter pour la liste de rôles format texte
     */
    getRoles(): string {
        return this.getMapAction()?.roles?.map(r => r.libelle).join("\n");
    }

    /**
     * Getter pour le nombre de rôles
     */
    getRolesCount(): number {
        return this.getMapAction()?.roles?.length;
    }

    /**
     * Getter pour l'ID Collab
     */
    getIdCollab(): number {
        return this.user?.idUser;
    }

    /**
     * Getter pour l'intitulé de l'objet
     * @param translateService service de traduction
     */
    getLibelleObjet(translateService: TranslateService): string {
        return '' + (this.idOd || translateService.instant('od.liste.numeroNonDefini')) + ' - ' + (this.objet || translateService.instant('od.liste.objetNonDefini'));
    }

    /**
     * Getter pour la validité de l'objet
     */
    isValid(): boolean {
        //Hardcodé en attendant l'implémentation des données calculées
        return true;
    }

    /**
     * Le budget de l'objet est-il conforme, afin d'autoriser une action workflow sur celui-ci
     */
    isBudgetOk(): boolean {
        return this.budgetOk;
    }
}